import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import RecentUnreadMessagesContainer from "../../Containers/RecentUnreadMessagesContainer";
import MeetingsContainer from "../../Containers/MeetingsContainer";
import FacultyCourseListContainer from "../../Containers/FacultyCourseListContainer";
import PlanStatusContainer from "../../Containers/PlanStatusContainer";
import CaseloadRiskChartContainer from "../../Containers/CaseloadRiskChartContainer";
import StudentMetricsChartContainer from "../../Containers/StudentMetricsChartContainer";
import TasksContainer from "../../Containers/TasksContainer";
import CaseloadTasksContainer from "../../Containers/CaseloadTasksContainer";
import DashboardReportContainer from "../../Containers/DashboardReportContainer";
import CaseloadKeyEngagementContainer from "../../Containers/CaseloadKeyEngagementContainer";
import KeyEngagementScoresByTeamContainer from "../../Containers/KeyEngagementScoresByTeamContainer";
import KeyEngagementScoresByPersonContainer from "../../Containers/KeyEngagementScoresByPersonContainer";
import { widgetIds } from "../../../Domain/Dashboard/Widget.model";
import AlertDashboardWidget from "../../Containers/AlertDashboardWidget";
import AlertModal from "../Alert/AlertModal";
import { useVirtualizedApp } from "../../Hooks/useVirtualizedApp";
import PersonTypeService from "../../../Services/PersonType.service";
import useHasVisibility from "../../Hooks/useHasVisibility";
import { Features } from "../../../Domain/Feature/Feature.model";
import { dashboardEditLink } from "../../Pages/Advisor/AdvisorRoutes";
import PageTitle from "../../UI/PageTitle/PageTitle";
const STUDENT_RETENTION_METRIC = "retention";
const STUDENT_PERSISTENCE_METRIC = "persistence";
const STUDENT_COURSE_COMPLETION_METRIC = "completion";
const DashboardComponent = (props) => {
    var _a;
    function getDashboardWidgetElement(dashboardWidget) {
        switch (dashboardWidget.widget.id) {
            case widgetIds.courses:
                return _jsx(FacultyCourseListContainer, {});
            case widgetIds.meetings:
                return _jsx(MeetingsContainer, {});
            case widgetIds.studentRetention:
                return _jsx(StudentMetricsChartContainer, { type: STUDENT_RETENTION_METRIC });
            case widgetIds.caseloadKeyEngagements:
                return _jsx(CaseloadKeyEngagementContainer, {});
            case widgetIds.studentPersistence:
                return (_jsx(StudentMetricsChartContainer, { type: STUDENT_PERSISTENCE_METRIC }));
            case widgetIds.courseCompletion:
                return (_jsx(StudentMetricsChartContainer, { type: STUDENT_COURSE_COMPLETION_METRIC }));
            case widgetIds.caseloadTermPersistenceRiskSummary:
                return _jsx(CaseloadRiskChartContainer, { courseRisk: false });
            case widgetIds.caseloadCourseCompletionRiskSummary:
                return _jsx(CaseloadRiskChartContainer, { courseRisk: true });
            case widgetIds.academicPlanSummary:
                return _jsx(PlanStatusContainer, {});
            case widgetIds.recentUnreadMessages:
                return _jsx(RecentUnreadMessagesContainer, {});
            case widgetIds.tasks:
                return _jsx(TasksContainer, {});
            case widgetIds.caseloadTasks:
                return _jsx(CaseloadTasksContainer, {});
            case widgetIds.keyEngagementScoresByTeam:
                return _jsx(KeyEngagementScoresByTeamContainer, {});
            case widgetIds.teamKeyEngagements:
                return _jsx(KeyEngagementScoresByPersonContainer, {});
            case widgetIds.report:
                return _jsx(DashboardReportContainer, { dashboardWidget: dashboardWidget });
            case widgetIds.activity:
                return _jsx(AlertDashboardWidget, {});
            default:
                console.log(`Dashboard widget not implemented yet: ${dashboardWidget.widget.title}`);
                return "";
        }
    }
    function getDashboardWidgetsForSection(sectionOrder, andGreater) {
        if (!props.widgets) {
            return [];
        }
        // If it's the last section in the layout, we need to grab any widgets in that
        // section, or in section numbers that are higher than the current one so when
        // layouts are changed so there are fewer sections, widgets aren't "lost".
        if (andGreater) {
            return props.widgets.filter((w) => w.section >= sectionOrder);
        }
        return props.widgets.filter((w) => w.section === sectionOrder);
    }
    const virtualizedAppContext = useVirtualizedApp();
    const [personTypes, setPersonTypes] = React.useState(null);
    React.useEffect(() => {
        PersonTypeService.getPersonTypesForApp(virtualizedAppContext.name).then((response) => {
            setPersonTypes(response.map(({ internalName }) => internalName));
        });
    }, [virtualizedAppContext.name]);
    const openAlertVisibility = useHasVisibility([Features.FILTER_BULK_ACTION_ALERT], personTypes);
    const [openAlertVisible, setOpenAlertVisible] = React.useState(false);
    React.useEffect(() => {
        if (openAlertVisibility) {
            setOpenAlertVisible(openAlertVisibility);
        }
    }, [openAlertVisibility]);
    const [alertModalOpen, setAlertModalOpen] = React.useState(false);
    if (props.widgets) {
        if (!props.dashboard) {
            return _jsx(_Fragment, {});
        }
        const sections = props.dashboard.dashboardLayout.dashboardLayoutSections;
        return (_jsxs("div", { className: "container-fluid", children: [_jsxs("div", { className: "d-flex justify-content-between py-3", children: [_jsx(PageTitle, { children: (_a = props.dashboard) === null || _a === void 0 ? void 0 : _a.title }), _jsxs("div", { children: [openAlertVisible && (_jsxs("button", { className: "btn btn-primary mr-2", onClick: () => setAlertModalOpen(true), children: [_jsx("span", { className: "fas fa-bell" }), " Send Alert"] })), _jsx(AlertModal, { isOpen: alertModalOpen, onModalClosed: () => setAlertModalOpen(false), size: "lg", appendToBody: true }), _jsxs(Link, { className: "btn btn-outline-secondary", to: dashboardEditLink({
                                        dashboardId: props.dashboard.id,
                                    }), title: "Dashboard Menu", children: [_jsx("span", { className: "fa fa-pencil-alt", "aria-hidden": "true" }), " Edit Dashboard"] })] })] }), _jsx("div", { className: "row pb-3", children: props.widgets && (_jsx(_Fragment, { children: sections.map((dls, index) => (_jsx("div", { className: `col-md-${dls.width}`, children: getDashboardWidgetsForSection(dls.sectionOrder, index === sections.length - 1).map((w) => (_jsx("div", { children: getDashboardWidgetElement(w) }, w.id))) }, dls.sectionOrder))) })) })] }));
    }
    return _jsx("div", {});
};
export default DashboardComponent;
